import { differenceInHours } from 'date-fns';

export const hoursElapsedSinceInsertedAt = (createdAt: string) => {
  const now = new Date().toISOString();

  return differenceInHours(new Date(now), new Date(createdAt));
};
